import React, { Component } from 'react'
import { TooltipPosition } from '../../objects/general'

export interface TooltipProps {
  position: TooltipPosition
  message: string
  hideTooltip?: boolean
  labelName?: string
  target?: string
  width?: number
  multiLine?: boolean
  children?: React.ReactNode
  style?: React.CSSProperties
  hasNote?: boolean
  noteMessage?: string
}

interface TooltipState {
  displayTooltip: boolean
}

class Tooltip extends Component<TooltipProps, TooltipState> {
  constructor(props: any) {
    super(props)
    this.state = {
      displayTooltip: false
    }
  }

  public mouseEnter = () => {
    this.setState({ displayTooltip: true })
  }

  public mouseLeave = () => {
    this.setState({ displayTooltip: false })
  }

  public tooltipFunc = () => {
    const {
      message,
      position,
      target,
      children,
      width,
      multiLine,
      style,
      hasNote,
      noteMessage
    } = this.props
    const { displayTooltip } = this.state

    return (
      <span className='tooltip' onMouseLeave={this.mouseLeave} style={style}>
        <span className='tooltip-trigger' onMouseOver={this.mouseEnter}>
          {target || children}
        </span>
        {displayTooltip && (
          <div
            style={width ? { width } : { width: 'auto' }}
            className={`tooltip-bubble tooltip-position--${position}`}>
            <div
              className={
                multiLine
                  ? 'tooltip-message tooltip-message-left'
                  : 'tooltip-message'
              }>
              {message}
              {hasNote ? (
                <div className='tooltip-note-message'>{noteMessage}</div>
              ) : null}
            </div>
          </div>
        )}
      </span>
    )
  }

  public render() {
    const { labelName, hideTooltip = false, children } = this.props
    if (!hideTooltip) {
      if (labelName) {
        return (
          <span className='tooltip-label-name'>
            {labelName}
            {this.tooltipFunc()}
          </span>
        )
      } else return this.tooltipFunc()
    } else if (children) {
      return children
    } else {
      return null
    }
  }
}
export default Tooltip
